


















import { Component, Vue } from 'vue-property-decorator';
import PasswordForgotForm from '@/components/auth/recovery/password-forgot/PasswordForgotForm.vue';

@Component({
	components: {
		PasswordForgotForm,
	}
})
export default class PasswordForgot extends Vue
{
	public success(data: any): void {
		this.$router.push({ name: 'login' });
	}
}
